module.exports = __webpack_public_path__ + "img/流水.7e3365cd.svg";